import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/orders/:id',
  title: 'Pedido',
  endpoint: '/app/purchase',
  breadcrumbs: [],
}
